import { numeroPreco } from '../../../../../Utils/promocao';
export { numeroPreco } from '../../../../../Utils/promocao';

export type PromocaoCatalogo = {
  ativa: boolean; valor: string; fusoHorario: string; diasSemana: number[];
  horarios: { inicio: string; fim: string }[]; inicio?: string; fim?: string;
};
export const novaPromocao = (): PromocaoCatalogo => ({ ativa: true, valor: '', fusoHorario: 'America/Sao_Paulo', diasSemana: [], horarios: [] });
export function erroPromocao(promo: PromocaoCatalogo | undefined, normal: any): string | undefined {
  if (!promo) return;
  const preco = !promo.ativa && !String(promo.valor ?? '').trim() ? 0 : numeroPreco(promo.valor);
  if (!Number.isFinite(preco) || preco < 0) return 'Informe um preço promocional válido.';
  if (promo.ativa && (!Number.isFinite(numeroPreco(normal)) || preco >= numeroPreco(normal))) return 'O preço promocional deve ser menor que o preço normal.';
  if ((promo.horarios || []).some(h => !/^([01]\d|2[0-3]):[0-5]\d$/.test(h.inicio) || !/^([01]\d|2[0-3]):[0-5]\d$/.test(h.fim))) return 'Preencha o início e o fim dos horários da promoção.';
  if ([promo.inicio, promo.fim].some(d => d !== undefined && !Number.isFinite(Date.parse(d)))) return 'Informe uma vigência válida para a promoção.';
  if (promo.inicio && promo.fim && Date.parse(promo.inicio) > Date.parse(promo.fim)) return 'O término da promoção deve ser posterior ao início.';
}
// O contrato do catálogo utiliza o horário de São Paulo (UTC−03).
export function dataPromocaoInput(value?: string): string {
  if (!value || !Number.isFinite(Date.parse(value))) return '';
  const parts = new Intl.DateTimeFormat('sv-SE', { timeZone: 'America/Sao_Paulo', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).formatToParts(new Date(value));
  const field = (name: string) => parts.find(p => p.type === name)?.value;
  return `${field('year')}-${field('month')}-${field('day')}T${field('hour')}:${field('minute')}`;
}
export const dataPromocaoSalvar = (value: string) => value ? `${value}:00-03:00` : undefined;

export function promocaoParaSalvar(promo: PromocaoCatalogo): PromocaoCatalogo {
  const preco = !promo.ativa && !String(promo.valor ?? '').trim() ? 0 : numeroPreco(promo.valor);
  return { ...promo, valor: preco.toFixed(2).replace('.', ','), diasSemana: promo.diasSemana || [], horarios: promo.horarios || [] };
}

export function mascararPrecoPromocional(value: any): string {
  const digits = String(value ?? '').replace(/\D/g, '').replace(/^0+(?=\d)/, '').slice(0, 11);
  if (!digits) return '';
  const padded = digits.padStart(3, '0');
  return `${padded.slice(0, -2).replace(/\B(?=(\d{3})+(?!\d))/g, '.')},${padded.slice(-2)}`;
}
